const FormatDate = (date) => {
    let dateAux = date.split(' ')[0];
    let realDate = dateAux.split('-')
    return realDate[2]+'/'+realDate[1]+'/'+realDate[0];
}

const formatToISO = (date) => {
    let dateAux = date.split(' ')[0];
    let realDate = dateAux.split('/')
    return realDate[2]+'-'+realDate[1]+'-'+realDate[0];
}

export {formatToISO, FormatDate}
export default FormatDate